import { type SxProps, type Theme } from "@mui/material/styles";

/**
 * Layered over the tooltip anchor's `inline-block`: a block that may shrink below its content is what
 * lets the text inside it clip at all in a flex row.
 */
export const TRUNCATED_TEXT_WRAPPER_SX: SxProps<Theme> = { display: "block", minWidth: 0, maxWidth: "100%" };

/** The full text can run to several lines, which read badly centred. */
export const TRUNCATED_TEXT_TOOLTIP_SX: SxProps<Theme> = { textAlign: "left" };

export const TRUNCATED_TEXT_LABEL_SX: SxProps<Theme> = { display: "block" };
